
function rotatingHelloBar() {
  const texts = document.querySelectorAll(".cw-hello-text");
  if (!texts.length) return;
  document.getElementById("headerBarContent").style.height = texts[0].offsetHeight + "px";
  let currentIndex = 0;

  function showNextText() {
    Array.from(texts).forEach((el) => el.classList.remove("hide"));
    texts[currentIndex].classList.remove("show");
    texts[currentIndex].classList.add("hide");
    const previousText = texts[currentIndex];
    setTimeout(function () {
      previousText.classList.remove("hide");
    }, 1000);

    currentIndex = (currentIndex + 1) % texts.length;

    texts[currentIndex].classList.remove("hide");
    texts[currentIndex].classList.add("show");

    document.getElementById("headerBarContent").style.height = texts[currentIndex].offsetHeight + "px";

    setTimeout(showNextText, 5000);
  }

  // Start the loop if there is more than one text element.
  if (texts.length > 1) {
    setTimeout(showNextText, 5000);
  }
}

// Function to fix the top margin of the global content based on the header height.
function fixGlobalContentTopMargin() {
  let headerHeight = document.querySelector("#site-header").offsetHeight;
  document.querySelector(".global-content-top-margin").style.marginTop = headerHeight + "px";
  document.querySelector(".v2__mobile-menu").style.marginTop = "-" + headerHeight + "px";
  document.querySelector(".v2__mobile-menu").style.paddingTop = headerHeight + "px";
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialize the rotating hello text.
  rotatingHelloBar()
  // Fix the top margin of the global content.
  fixGlobalContentTopMargin();

  document.querySelectorAll(".v2__preventClick").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
    });
  });

  const siteHeader = document.querySelector(".v2__menu-levels");
  const menuOverlay = document.getElementById("menuOverlay");
  const disclaimer_d = document.querySelector(".v2__disclaimer-d");
  const bodyDOM = document.querySelector("body");
  let scrollX = window.scrollX;
  let scrollY = window.scrollY;
  let timeoutIdMain;
  let timeoutIdSub;
  let boundScrollLock;
  const scrollLock = function (scrollX, scrollY) {
    window.scrollTo(scrollX, scrollY);
  };

  const headerLinksMainMenu = document.querySelectorAll(".v2__main-menu-list .main-menu-item > .v2__header-link");
  headerLinksMainMenu.forEach((link) => {
    link.addEventListener("mouseover", () => {
      if (!link.classList.contains("active")) {
        clearTimeout(timeoutIdMain);
        timeoutIdMain = setTimeout(() => handleMenuMouseOver(link, true), 250);
      }
    });
    link.addEventListener("mouseleave", () => clearTimeout(timeoutIdMain));
  });

  const headerLinksSubMenu = document.querySelectorAll(".v2__sub-menu-list .sub-menu-item > .v2__header-link");
  headerLinksSubMenu.forEach((link) => {
    markSubMenuItemsWithDropdowns(link);
    link.addEventListener("mouseover", (e) => {
      if (!link.classList.contains("active")) {
        clearTimeout(timeoutIdSub);
        if (!e.isTrusted) {
          handleMenuMouseOver(link, false);
        } else {
          timeoutIdSub = setTimeout(() => handleMenuMouseOver(link, false), 150);
        }
      }
    });
    link.addEventListener("mouseleave", () => clearTimeout(timeoutIdSub));
  });

  // When the mouse leaves the entire header area, clear all menus.
  siteHeader.addEventListener("mouseleave", () => {
    clearMenus();
    clearTimeout(timeoutIdMain);
    clearTimeout(timeoutIdSub);
  });


  function handleMenuMouseOver(link, isMain) {
    console.log('handleMenuMouseOver', isMain)
    if (isMain) {
      clearMenus();
    } else {
      clearDropdowns();
    }
    setActiveClass(link);
    const dataTitle = link.getAttribute("data-title");
    showMenuOrDropdown(dataTitle, isMain);
  }


  function clearMenus() {
    console.log('clear menu')
    bodyDOM.style.overflowY = "auto";
    if (window.outerWidth - document.body.clientWidth) {
      window.removeEventListener("scroll", boundScrollLock);
    }
    document.querySelectorAll(".v2__sub-menu, .v2__dropdowns").forEach((menu) => {
      menu.style.display = "none";
      menu.classList.remove("show");
    });
    document.querySelectorAll(".v2__header-link").forEach((link) => {
      link.classList.remove("active");
    });
    menuOverlay.style.opacity = "0";
    disclaimer_d.style.display = "none";
    disclaimer_d.style.opacity = "0";
  }

  function clearDropdowns() {
    console.log('clear dropdown')
    bodyDOM.style.overflowY = "auto";
    if (window.outerWidth - document.body.clientWidth) {
      window.removeEventListener("scroll", boundScrollLock);
    }
    document.querySelectorAll(".v2__dropdowns").forEach((dropdown) => {
      dropdown.style.display = "none";
      dropdown.classList.remove("show");
    });
    disclaimer_d.style.display = "none";
    disclaimer_d.style.opacity = "0";
    if (!document.querySelector(".v2__sub-menu.show, .v2__dropdowns.show")) {
      menuOverlay.style.opacity = "0";
    }
  }

  function showMenuOrDropdown(dataTitle, isMainMenu) {
    const targetElement = document.querySelector("." + dataTitle);
    if (targetElement) {
      targetElement.style.display = "block";
      targetElement.classList.add("show");
      menuOverlay.style.opacity = "1";
      disclaimer_d.style.display = "block";
      disclaimer_d.style.opacity = "1";
      const shown_dropdown = document.querySelector('.v2__dropdowns.show');
      const dropdown_offsetBottom = shown_dropdown?.offsetTop + shown_dropdown?.offsetHeight
      if (dropdown_offsetBottom) {
        disclaimer_d.style.top = dropdown_offsetBottom + "px";
      }
      if (!(window.outerWidth - document.body.clientWidth)) {
        bodyDOM.style.overflowY = "hidden";
      } else {
        scrollX = window.scrollX;
        scrollY = window.scrollY;
        boundScrollLock = scrollLock.bind(null, scrollX, scrollY);
        window.addEventListener("scroll", boundScrollLock);
      }

      if (isMainMenu) {
        const firstSubMenuItem = targetElement.querySelector(".v2__sub-menu-list .v2__header-link");
        if (firstSubMenuItem && !firstSubMenuItem.classList.contains("active")) {
          firstSubMenuItem.dispatchEvent(
            new MouseEvent("mouseover", {
              view: window,
              bubbles: true,
              cancelable: true,
            })
          );
        } else {
          bodyDOM.style.overflowY = "auto";
          if (window.outerWidth - document.body.clientWidth) {
            window.removeEventListener("scroll", boundScrollLock);
          }
        }
      }
    }
  }

  function setActiveClass(element) {
    const allActiveLinks = document.querySelectorAll(".v2__header-link.active");
    allActiveLinks.forEach((activeLink) => {
      if (
        activeLink.closest(".v2__sub-menu-list, .v2__main-menu-list") ===
        element.closest(".v2__sub-menu-list, .v2__main-menu-list")
      ) {
        activeLink.classList.remove("active");
      }
    });
    element.classList.add("active");
  }

  function markSubMenuItemsWithDropdowns(link) {
    const dataTitle = link.getAttribute("data-title");
    const targetDropdown = document.querySelector("." + dataTitle);
    if (targetDropdown) {
      link.classList.add("v2__dropdown_exist");
    }
  }
});

function setMobileMenuHeading() {
  const h2Elements = document.querySelectorAll(".v2__mm-page .v2__mm-page__heading[data-parent]");
  h2Elements.forEach((element) => {
    const parentValue = element.getAttribute("data-parent");
    const childElement = document.querySelector(`[data-child="${parentValue}"]`);
    if (childElement) {
      element.textContent = childElement.textContent;
    }
  });
}

let animationDirection = "rightToLeft";

document.addEventListener("DOMContentLoaded", function () {

  const hamburgerCheckbox = document.querySelector("input.checkbox-hamburger");
  const mobileMenu = document.querySelector(".v2__mobile-menu");
  const body = document.body;

  hamburgerCheckbox.addEventListener("change", function () {
    if (this.checked) {
      mobileMenu.style.transform = "translateX(0)";
      body.style.overflow = "hidden";
      const v2_predictiveSearchResultsMobile = document.getElementById("predictive-search-mobile");
      const v2_predictiveSearchResults = document.getElementById("predictive-search");
      setDisclaimer();
      if (
        v2_predictiveSearchResults.classList.contains("show") ||
        v2_predictiveSearchResultsMobile.classList.contains("active")
      ) {
        v2_predictiveSearchResults.classList.remove("show");
        v2_predictiveSearchResultsMobile.classList.remove("active");
      }
    } else {
      mobileMenu.style.transform = "translateX(100%)";
      body.style.overflow = "auto";
    }
  });

  setMobileMenuHeading();

  function setDisclaimer() {

  }

  function showPage(target, direction = 'forward') {
    if (direction === 'forward') {
      target.classList.add("active");
      target.style.display = "block";
    } else {
      target.classList.remove("active");
      target.style.display = "none";
    }
  }

  const topLevelPage = document.querySelector(".v2__mobile-menu > .container > .v2__mm-page");
  if (topLevelPage) {
    showPage(topLevelPage);
  }

  document.querySelectorAll(".v2__mobile-menu-link[data-child]").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const childAttr = this.getAttribute("data-child");
      const parentLi = this.closest("li");
      const childPage = parentLi ? parentLi.querySelector(`.v2__mm-page[data-parent="${childAttr}"]`) : null;
      const fallbackChildPage = document.querySelector(`.v2__mm-page[data-parent="${childAttr}"]`);
      const pageToShow = childPage || fallbackChildPage;

      if (pageToShow) {
        showPage(pageToShow, 'forward');
      }
    });
  });

  document.querySelectorAll("[back-to]").forEach(button => {
    button.addEventListener("click", function () {
      const backToAttr = this.getAttribute("back-to");
      const parentLink = document.querySelector(`.v2__mobile-menu-link[data-child="${backToAttr}"]`);

      let childPage = null;
      if (parentLink) {
        const parentLi = parentLink.closest("li");
        childPage = parentLi ? parentLi.querySelector(`.v2__mm-page[data-parent="${backToAttr}"]`) : null;
        childPage = childPage || document.querySelector(`.v2__mm-page[data-parent="${backToAttr}"]`);
      }

      if (childPage) {
        showPage(childPage, 'back');
      } else {
        if (topLevelPage) showPage(topLevelPage, 'forward');
      }
    });
  });

});
